<template>
  <div class="gs-promo-tools-assets">
    <promotools @logoutAffiliate="logoutAffiliate" />
  </div>
</template>

<script>
import Promotools from '@/components/promotools/Promotools.vue';

export default {
  name: 'PromoToolsAssets',
  components: {
    Promotools,
  },
  data() {
    return {
    };
  },
  methods: {
    logoutAffiliate() {
      this.$emit('userLoggedOut', 1);
    },
  }
};
</script>

<style>
.swipesEditor {
  height: 32rem;
}

.gs-default-tabs-item:focus {
  outline: none !important;
  outline-style: none !important;
}

.embed-container {
  margin-bottom: 1.1em;
  margin-top: 1.5em;
  position: relative;
  padding-bottom: 56.25%;
  height: 0;
  overflow: hidden;
  max-width: 100%;
}
.embed-container iframe,
.embed-container object,
.embed-container embed {
  position: absolute;
  top: 0;
  left: 0;
  width: 96%;
  height: 100%;
  margin-left: 2%;
  margin-right: 2%;
}

.vue-tags-input {
  max-width: 100% !important;
}

.vue-tags-input .ti-tags .ti-tag {
  background-color: var(--brand-primary) !important;
}
</style>


<style scoped>
.gs-promo-tools-assets {
  min-width: 0;
}

.fade-enter-active {
  transition: opacity 1.5s;
}
.fade-leave-active {
  opacity: 0;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
</style>
